import { Axios, AxiosResponse } from "axios";
import {Store} from "../../configureStore";
import { put, call, takeLatest,select } from "redux-saga/effects";
import { setSignupPopup as setSignupPopupAction } from "../navigation/navigationActions";
import { storeCartRestaurantDetails, addCartItem, setItemLevelPromoCode } from "../cart/cartActions";
import {
  successRestaurantDetails,
  failedRestaurantDetails,
  successRestaurantMenuDetails,
  failedRestaurantMenuDetails,
  successFeedbackDetails,
  failedFeedbackDetails,
  successSubmitFeedbackDetails,
  failedSubmitFeedbackDetails,
  successRestaurants,
  failedRestaurants,
  successGetServingLocations,
  failedGetServingLocations,
  getRestaurantDetailsByLocationIdSuccess,
  getActiveOrderRestaurant,
  getActiveOrderRestaurantSuccess,
  getMasterHomePageDetailsFailed,
  getMasterHomePageDetailsSuccess,
  getRestaurantTableDetailsSuccess,
  getRestaurantTableDetailsFailed,
  addDeliveryAddressRequest,
  addDeliveryAddressSuccess,
  addDeliveryAddressFailure,
  viewDeliveryAddressSuccess,
  viewDeliveryAddressFailure,
  editDeliveryAddressSuccess,
  editDeliveryAddressFailure,
  deleteDeliveryAddressSuccess,
  deleteDeliveryAddressFailure,
  viewDeliveryAddressRequest,
  AddFavSuccess,
  AddFavFailure,
  RemoveFavSuccess,
  RemoveFavFailure,
  GetFavSuccess,
  GetFavFailure,
  GetFavRequest,
  exploreMenuSuccess,
  exploreMenuFailure,
  getCouponSuccess,
  getCouponFailure,
  validateCouponSuccess,
  validateCouponFailure,
  redeemCouponSuccess,
  redeemCouponFailure,
  appliedCoupon,
  validateCouponFailureMessage,
} from "./restaurantAction";
import {
  addDeliveryAddress,
  AddFav,
  deleteDeliveryAddress,
  editDeliveryAddress,
  exploreMenu,
  getCoupon,
  getFav,
  getFeedbackDetails,
  getmasterRestaurantHomePageDetails,
  getRestaurantDetails,
  getRestaurantDetailsbyLocationId,
  getRestaurantMenuDetails,
  getRestaurantMenuDetails1,
  getRestaurantMenuDetailsByEventDate,
  getRestaurantMenuDetailsByEventDate1,
  getRestaurants,
  getRestaurantTableDetails,
  redeemCoupon,
  removeFav,
  submitFeedback,
  validateCoupon,
  viewDeliveryAddress,
} from "./restaurantAPI";
import { getCookie } from "../../../helper/cookieHelper";
import { USER_DETAILS, USER_ID } from "../../constants";
import {
  ACTIVE_ORDER_RESTAURANT_REQUEST,
  ADD_DELIVERY_ADDRESS_REQUEST,
  ADD_FAV_REQUEST,
  DELETE_DELIVERY_ADDRESS_REQUEST,
  EDIT_DELIVERY_ADDRESS_REQUEST,
  FEEDBACK_DETAIL_REQUEST,
  GET_COUPONS_REQUEST,
  GET_EXPLORE_MENU_REQUEST,
  GET_FAV_REQUEST,
  GET_MASTER_HOME_PAGE_DETAILS,
  GET_RESTAURANT_TABLE_DETAILS,
  REDEEM_COUPONS_REQUEST,
  REMOVE_FAV_REQUEST,
  RESTAURANTS_REQUEST,
  RESTAURANT_DETAIL_LOCATION_ID_REQUEST,
  RESTAURANT_DETAIL_REQUEST,
  RESTAURANT_MENU_DETAIL_REQUEST,
  RESTAURANT_MENU_DETAIL_REQUEST_BY_DATE,
  SERVING_RESTAURANTS_REQUEST,
  SUBMIT_FEEDBACK_DETAIL_REQUEST,
  UPDATE_CURRENT_ACTIVE_MENU,
  VALIDATE_COUPONS_REQUEST,
  VIEW_DELIVERY_ADDRESS_REQUEST,
} from "./restaurantContants";
import {
  FeedbackQuestion,
  RestaurantMenuRequest,
  RestaurantMenuResponse,
  RestaurantsRequestParams,
  SubmitFeedbackDetail,
  RestaurantItemDetail,
  RestaurantDetailRequest,
  RestaurantDetailByLocationIdRequest,
} from "./restaurantModels";
import { getAvailableCatgorySubCategory ,getAvailableCatgorySubCategory1} from "../../utils/menu-helper-utils";
import { clearAllAutoApplySuppression, getOfferCategory, bogoEqualOrLesserSatisfied, isExclusiveCoupon, isMenuItemOrderable, isOrderLevelOfferLocked } from "../../utils/offer-utils";
import { getEventDate, getEventSlug } from "../selectors";
import { decryptJson } from "../../utils/react-ec-utils";
import { showErrorToast, showErrorToastDesktop } from "../../utils/toastUtils";
import { validateAndParseResponse } from "../../utils/hmac-utils";

function* getLocationRestaurantsSaga(action: any) {
  try {
    const requestDetails = action.payload as RestaurantsRequestParams;

    const response: AxiosResponse = yield call(getRestaurants, requestDetails);
    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText)
      yield put(successRestaurants(data as RestaurantItemDetail[]));
    } else if (response.status === 400) {
      yield put(failedRestaurants({ message: "Please Try Again" }));
    }
  } catch (err) {
    yield put(failedRestaurants({ message: "Please Try Again" }));
  }
}

function* getServingRestaurantsSaga(action: any) {
  try {
    const requestDetails = action.payload as RestaurantsRequestParams;

    const response: AxiosResponse = yield call(getRestaurants, requestDetails);
    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText)
      yield put(
        successGetServingLocations(data as RestaurantItemDetail[])
      );
    } else if (response.status === 400) {
      yield put(failedGetServingLocations({ message: "Please Try Again" }));
    }
  } catch (err) {
    yield put(failedGetServingLocations({ message: "Please Try Again" }));
  }
}

function* getRestaurantDetailsSaga(action: any) {
  let payload = action.payload as RestaurantDetailRequest;

  const eventSlug: string | null = yield select(getEventSlug); 
  const eventDate: boolean = yield select(getEventDate);     
  const isEventOrder = Boolean(eventDate) || Boolean(eventSlug);
  
  try {
    const response: AxiosResponse = yield call(
      getRestaurantDetails,
      payload.slug as string
    );

    if (response.status === 200) {   
      const decryptedData = decryptJson(response.data.encryptedText)   
      yield put(successRestaurantDetails({ detail: decryptedData,isEventOrder}));

      localStorage.removeItem('theme')
  
      

      if ( payload?.sagaCallBack != null &&typeof payload?.sagaCallBack === 'function') {
        console.log({decryptedData});
        
        payload.sagaCallBack(true, decryptedData?.deliveryCutOffTimeExceeds, decryptedData?.pickupCutOffTimeExceeds, decryptedData);
      }
    } else{
      yield put(failedRestaurantDetails({ message: "Please Try Again",isEventOrder }));
      if ( payload?.sagaCallBack != null &&typeof payload?.sagaCallBack === 'function') {
        payload.sagaCallBack(false,1,1,'');
      }
    }
  } catch (err) {
    // TEMP DEBUG: this catch previously swallowed the error with no logging, making
    // decrypt/parse failures indistinguishable from network failures. Remove once diagnosed.
    console.error('getRestaurantDetailsSaga failed:', err);
    yield put(failedRestaurantDetails({ message: "Please Try Again",isEventOrder }));
    if ( payload?.sagaCallBack != null &&typeof payload?.sagaCallBack === 'function') {
      payload.sagaCallBack(false,1,1,'');
    }
  }
}

function* getRestaurantDetailsByLocationIdSaga(action: any) {
  const eventSlug: string | null = yield select(getEventSlug); 
  const eventDate: boolean = yield select(getEventDate);     

  const isEventOrder = Boolean(eventDate) || Boolean(eventSlug);
  try {
    let payload = action.payload as RestaurantDetailByLocationIdRequest;
    const response: AxiosResponse = yield call(
      getRestaurantDetailsbyLocationId,
      payload.locationId
    );
    if (response.status === 200) {
      const decryptedData = decryptJson(response.data.encryptedText)
      yield put(getRestaurantDetailsByLocationIdSuccess({ details: decryptedData,isEventOrder}));
    } else if (response.status === 400) {
      yield put(failedRestaurantDetails({ message: "Please Try Again",isEventOrder }));
    }
  } catch (err) {
    yield put(failedRestaurantDetails({ message: "Please Try Again",isEventOrder }));
  }
}

function* getActiveOrderRestaurantSaga(action: any) {
  try {
    let payload = action.payload as RestaurantDetailByLocationIdRequest;
    const response: AxiosResponse = yield call(
      getRestaurantDetailsbyLocationId,
      payload.locationId
    );
    if (response.status === 200) {
      const decryptedData = decryptJson(response.data.encryptedText)
      yield put(getActiveOrderRestaurantSuccess(decryptedData));
    } else if (response.status === 400) {
      yield put(failedRestaurantDetails({ message: "Please Try Again" }));
    }
  } catch (err) {
    yield put(failedRestaurantDetails({ message: "Please Try Again" }));
  }
}

function* getRestaurantMenuDetailsByDateSaga(action: any) {
  try {
    const restaurantDetails = (Store.getState() as any).restaurant.currentRestaurantDetail;

const restaurantMenu= restaurantDetails?.isProductCatalogV2Enabled ? getRestaurantMenuDetailsByEventDate : getRestaurantMenuDetailsByEventDate1 
     let EventMenu:any
     const response: AxiosResponse = yield call(restaurantMenu,action.payload as RestaurantMenuRequest);
    if (response.status === 200) {
      if(!restaurantDetails?.isProductCatalogV2Enabled && response?.data?.encryptedText){
         const decryptdata=decryptJson(response.data.encryptedText)
         const responseData = decryptdata as RestaurantMenuResponse;
         EventMenu=responseData
      }
      else{
           const responseData = response.data as RestaurantMenuResponse;
           EventMenu=responseData
      } 
      const { categoryTypes, subCategoryTypes } =  restaurantDetails?.isProductCatalogV2Enabled
          ? getAvailableCatgorySubCategory(EventMenu.menu)
          : getAvailableCatgorySubCategory1(EventMenu.menu);

      yield put(
        storeCartRestaurantDetails(
          (Store.getState() as any).restaurant.currentRestaurantDetail,
         EventMenu.orderTax || [],
          EventMenu.defaultItemTax
        )
      );
      const rData = {...EventMenu, categoryTypes, subCategoryTypes,eventSlot:EventMenu?.eventOrderSlot }
      yield put(successRestaurantMenuDetails(rData));
            action.payload?.sagaSuccessCB && typeof action.payload?.sagaSuccessCB === 'function' && action.payload?.sagaSuccessCB(rData?.menu)

    } else {
      yield put(failedRestaurantMenuDetails({ message: "Please Try Again" }));
    }
  } catch (err) {
    yield put(failedRestaurantMenuDetails({ message: "Please Try Again" }));
  }
}

function* getRestaurantMenuDetailsSaga(action: any) {
const restaurantDetails = (Store.getState() as any).restaurant.currentRestaurantDetail;
const restaurantMenu= restaurantDetails?.isProductCatalogV2Enabled ? getRestaurantMenuDetails : getRestaurantMenuDetails1
  try {
    const response: AxiosResponse = yield call(
      restaurantMenu,
      action.payload as RestaurantMenuRequest
    );
    if (response.status === 200) {
      yield put({ type: UPDATE_CURRENT_ACTIVE_MENU, payload: action.payload.type })

      // const responseData = decryptJson(response.data.encryptedText) as RestaurantMenuResponse;
      let responseData = response.data as RestaurantMenuResponse;


      yield put(
        storeCartRestaurantDetails(
          (Store.getState() as any).restaurant.currentRestaurantDetail,
          responseData.orderTax || [],
          responseData.defaultItemTax
        )
      );
      if (restaurantDetails?.isProductCatalogV2Enabled) {
        responseData = response.data as RestaurantMenuResponse;
        const { categoryTypes, subCategoryTypes } = restaurantDetails?.isProductCatalogV2Enabled
          ? getAvailableCatgorySubCategory(responseData.menu)
          : getAvailableCatgorySubCategory1(responseData.menu);
        const rData = { ...responseData, categoryTypes, subCategoryTypes };
        yield put(successRestaurantMenuDetails(rData));
        action.payload?.sagaSuccessCB &&
          typeof action.payload?.sagaSuccessCB === 'function' &&
          action.payload?.sagaSuccessCB(rData?.menu);
      } else {
        responseData = decryptJson(response.data.encryptedText) as RestaurantMenuResponse;
        const { categoryTypes, subCategoryTypes } = restaurantDetails?.isProductCatalogV2Enabled
          ? getAvailableCatgorySubCategory(responseData.menu)
          : getAvailableCatgorySubCategory1(responseData.menu);
        const rData = { ...responseData, categoryTypes, subCategoryTypes };
        yield put(successRestaurantMenuDetails(rData));
        action.payload?.sagaSuccessCB &&
          typeof action.payload?.sagaSuccessCB === 'function' &&
          action.payload?.sagaSuccessCB(rData?.menu);
      }
      
    } else{
      yield put(failedRestaurantMenuDetails({ message: "Please Try Again" }));
    }
  } catch (err) {
    yield put(failedRestaurantMenuDetails({ message: "Please Try Again" }));
  }
}


//Explore Menu
function* getExploreMenuSaga(action: any) {
  try{
    const response: AxiosResponse = yield call(exploreMenu, action.payload)

    if(response.status === 200){
      yield put(exploreMenuSuccess(response.data))
    }else{
      yield put(exploreMenuFailure(response.data))
    }
  }catch(err: any){
    yield put(exploreMenuFailure(err))
  }
}

function* getMasterHomePageDetailsSaga(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getmasterRestaurantHomePageDetails,
      action.payload as string
    );
    if (response.status === 200) {
      yield put(getMasterHomePageDetailsSuccess(response.data));
    } else if (response.status === 400) {
      // yield put(getMasterHomePageDetailsFailed({ message: "Please Try Again" }));
      console.info("Failed to get master homepage Details::");
    }
  } catch (err) {
    console.error("Failed to get master homepage Details::", err);
  }
}

function* getFeedbackDetailsSaga(action: any) {
  try {
    const response: AxiosResponse = yield call(getFeedbackDetails);
    const decryptdata=decryptJson(response?.data?.encryptedText)
    if (response.status === 200) {
      yield put(
        successFeedbackDetails(decryptdata.question as FeedbackQuestion[])
      );
    } else {
      yield put(failedFeedbackDetails());
    }
  } catch (err) {
    yield put(failedFeedbackDetails());
  }
}

function* SubmitFeedbackDetailsSaga(action: any):any {
  try {
    const response: AxiosResponse = yield call(
      submitFeedback,
      action.payload as SubmitFeedbackDetail
    );

    if (response.status === 200) {
      yield put(successSubmitFeedbackDetails());
    } else {
      yield put(failedSubmitFeedbackDetails());
    }
  } catch (err) {
    yield put(failedSubmitFeedbackDetails());
  }
}

function* getRestaurantTableDetailsSaga(action: any) {
  let payload = action.payload as string;

  try {
    const response: AxiosResponse = yield call(
      getRestaurantTableDetails,
      payload as string
    );
    if (response.status === 200) {
      const data = decryptJson(response.data.encryptedText)
      yield put(getRestaurantTableDetailsSuccess(data));
    } else if (response.status === 400) {
      yield put(getRestaurantTableDetailsFailed());
    }
  } catch (err) {
    yield put(getRestaurantTableDetailsFailed());
  }
}

function* addDeliveryAddressSaga(action: any):any {
  let payload = action.payload
 const isMobile = window.innerWidth <= 768;
  try{
    const response: AxiosResponse = yield call(addDeliveryAddress, payload)
     const  parsedResponse = yield call(
            validateAndParseResponse,
           response?.data
          );
       if(!parsedResponse?.valid)
               {
                  if (isMobile) {
                   showErrorToast(parsedResponse?.message || "Failed to update profile, Please try Again");
                 } else {
                   showErrorToastDesktop(parsedResponse?.message || "Failed to update profile, Please try Again");
                 }
               return ;
        }
    if(response.status === 200){
      yield put(addDeliveryAddressSuccess(response.data?.data))
      yield put(viewDeliveryAddressRequest())
    }else{
      
       if(isMobile){
        showErrorToast(response?.data?.message)
      }else{
        showErrorToastDesktop(response?.data?.message)
      }
      
   
      yield put(addDeliveryAddressFailure(response.data))
    }
  }catch(err: any){

      if(isMobile){
        showErrorToast('Something went wrong !')
      }else{
        showErrorToastDesktop('Something went wrong !')
      }
    
    yield put(addDeliveryAddressFailure(err))
  }
}

function* viewDeliveryAddressSaga(action: any):any {
    const isMobile = window.innerWidth <= 768;
  try{
    // Check if customerID exists before making the API call
    const customerID = getCookie(USER_ID);
    
    if (!customerID) {
      // Don't make API call if no customerID (prevents 401 after refresh/403)
      // Silently return without dispatching failure to avoid triggering 401 handler
      return;
    }
    
    const response: AxiosResponse = yield call(viewDeliveryAddress);
         const parsedResponse = yield call(
              validateAndParseResponse,
              response.data
            ); 
            if(!parsedResponse?.valid)
                      {
                         if (isMobile) {
                          showErrorToast(parsedResponse?.message || "Failed to update profile, Please try Again");
                        } else {
                          showErrorToastDesktop(parsedResponse?.message || "Failed to update profile, Please try Again");
                        }
                      return ;
                      }  
           
    if(response.status === 200){
      yield put(viewDeliveryAddressSuccess(response.data.data))
    }else{
      yield put(viewDeliveryAddressFailure(response.data))
    }
  }catch(err: any){
    // Only dispatch failure if it's not a 401 from missing customerID
    // This prevents the 401 interceptor from triggering when customerID is missing
    if (err?.response?.status !== 401 || err?.response?.data?.message !== 'Customer ID not found') {
      yield put(viewDeliveryAddressFailure(err))
    }
    // Silently handle missing customerID case
  }
}


function* editDeliveryAddressSaga(action: any) :any{

  const isMobile = window.innerWidth <= 768;
  let payload = action.payload

  try{
    const response: AxiosResponse = yield call(editDeliveryAddress, payload)
     const  parsedResponse = yield call(
            validateAndParseResponse,
           response?.data
          );
       if(!parsedResponse?.valid)
               {
                  if (isMobile) {
                   showErrorToast(parsedResponse?.message || "Failed to update profile, Please try Again");
                 } else {
                   showErrorToastDesktop(parsedResponse?.message || "Failed to update profile, Please try Again");
                 }
               return ;
        }
    if(response.status === 200){
      yield put(editDeliveryAddressSuccess(response.data.data))
      yield put(viewDeliveryAddressRequest())
    }else{

      if(isMobile){
        showErrorToast(response?.data?.message)
      }else{
        showErrorToastDesktop(response?.data?.message)
      }

      yield put(editDeliveryAddressFailure(response.data))
    }
  }catch(err: any){
    yield put(editDeliveryAddressFailure(err))
  }
}

function* deleteDeliveryAddressSaga(action: any) {
  let payload = action.payload

  try{
    const response: AxiosResponse = yield call(deleteDeliveryAddress, payload)
    if(response.status === 200){
      yield put(deleteDeliveryAddressSuccess(response.data))
    }else{
      yield put(deleteDeliveryAddressFailure(response.data))
    }
  }catch(err: any){
    yield put(deleteDeliveryAddressFailure(err))
  }
}

function* addFavSaga(action: any) :any{
  let payload = action.payload
  const isMobile = window.innerWidth <= 768;
  const userDetails = getCookie(USER_DETAILS) || {};
  try{
    const response: AxiosResponse = yield call(AddFav, payload);
     const  parsedResponse = yield call(
            validateAndParseResponse,
           response?.data
          );
       if(!parsedResponse?.valid)
               {
                  if (isMobile) {
                   showErrorToast(parsedResponse?.message || "Failed to update profile, Please try Again");
                 } else {
                   showErrorToastDesktop(parsedResponse?.message || "Failed to update profile, Please try Again");
                 }
               return ;
        }
    if(response.status === 200){
      yield put(AddFavSuccess(response.data.data))
      yield put(GetFavRequest({
        locationId: payload?.locationId,
        customerId: payload?.customerId,
        emailId: userDetails?.email || "",
        mobileNo: userDetails?.mobilePhone || ""
      }))
    }else{
      yield put(AddFavFailure(response.data))
    }
  }catch(err: any){
    yield put(AddFavFailure(err))
  }
}
function* removeFavSaga(action: any) {
  let payload = action.payload
  const userDetails = getCookie(USER_DETAILS) || {};

  try{
    const response: AxiosResponse = yield call(removeFav, payload)
    if(response.status === 200){
      yield put(RemoveFavSuccess(response.data))
     yield put(GetFavRequest({
       locationId: payload?.locationId,
       customerId: payload?.customerId,
       emailId: userDetails?.email || "",
       mobileNo: userDetails?.mobilePhone || ""
     }))
    }else{
      yield put(RemoveFavFailure(response.data))
    }
  }catch(err: any){
    yield put(RemoveFavFailure(err))
  }
}
function* getFavSaga(action: any) {
  let payload = action.payload

  try{
    const response: AxiosResponse = yield call(getFav, payload)
    if(response.status === 200){
      yield put(GetFavSuccess(response.data.data))
    }else{
      yield put(GetFavFailure(response.data))
    }
  }catch(err: any){
    yield put(GetFavFailure(err))
  }
}


//coupon saga


function* getCouponSaga(action: any) {
  let payload = action.payload

  try{
    const response: AxiosResponse = yield call(getCoupon, payload)
    if(response.status === 200){
      yield put(getCouponSuccess(response.data))
    }else{
      yield put(getCouponFailure(response.data))
    }
  }catch(err: any){
    yield put(getCouponFailure(err))
  }
}

// Builds the minimum required CartItemOption[] and modifierIds string for an
// item-level offer add. Picks default (default=1) options first, then base
// (isBase=1), then first available, until minRequired is satisfied per group.
// Supports both the new modifier-group format and the legacy flat format.
function buildDefaultRequiredOptions(customization: any[]): {
  options: Array<{ typeId: string; modifierOptionId: string; modifier: string; optionName: string; quantity: string; price: string }>;
  modifierPrice: number;
  modifierIds: string;
} {
  const options: Array<{ typeId: string; modifierOptionId: string; modifier: string; optionName: string; quantity: string; price: string }> = [];
  let modifierPrice = 0;

  if (!Array.isArray(customization) || customization.length === 0) {
    return { options, modifierPrice, modifierIds: '' };
  }

  const isNewFormat =
    customization[0]?.modifierId != null && Array.isArray(customization[0]?.options);

  if (isNewFormat) {
    customization.forEach((group: any) => {
      const min = Number(group?.minRequired ?? 0);
      if (min <= 0) return;
      const available = (Array.isArray(group.options) ? group.options : []).filter(
        (o: any) => o?.optionAvailable === 1 || o?.optionAvailable == null
      );
      // Priority: default=1 first, then isBase=1, then first available
      const sorted = [
        ...available.filter((o: any) => o?.default === 1 || o?.default === true),
        ...available.filter((o: any) =>
          !(o?.default === 1 || o?.default === true) && (o?.isBase === 1 || o?.isBase === true)
        ),
        ...available.filter((o: any) =>
          !(o?.default === 1 || o?.default === true) && !(o?.isBase === 1 || o?.isBase === true)
        ),
      ];
      sorted.slice(0, min).forEach((opt: any) => {
        const price = Number(opt?.price ?? 0);
        modifierPrice += price;
        options.push({
          typeId: group.modifierId,
          modifierOptionId: opt.modifierOptionId,
          modifier: group.modifierName || '',
          optionName: opt.optionName || '',
          quantity: '1',
          price: String(price),
        });
      });
    });
  } else {
    // Legacy flat format — group by typeId
    const groups: Record<string, { minRequired: number; type: string; opts: any[] }> = {};
    customization.forEach((item: any) => {
      const tid = item?.typeId;
      if (!tid) return;
      if (!groups[tid]) {
        groups[tid] = { minRequired: Number(item?.minRequired ?? 0), type: item?.type || '', opts: [] };
      }
      if (item?.optionAvailable === 1 || item?.optionAvailable == null) {
        groups[tid].opts.push(item);
      }
    });
    Object.values(groups).forEach((group) => {
      if (group.minRequired <= 0) return;
      const sorted = [
        ...group.opts.filter((o: any) => o?.isBase === 1 || o?.isBase === true),
        ...group.opts.filter((o: any) => !(o?.isBase === 1 || o?.isBase === true)),
      ];
      sorted.slice(0, group.minRequired).forEach((opt: any) => {
        const price = Number(opt?.price ?? 0);
        modifierPrice += price;
        options.push({
          typeId: opt.typeId,
          modifierOptionId: opt.modifierOptionId,
          modifier: group.type,
          optionName: opt.optionName || '',
          quantity: '1',
          price: String(price),
        });
      });
    });
  }

  const modifierIds = options.map((o) => o.modifierOptionId).join(',');
  return { options, modifierPrice, modifierIds };
}

function* validateCouponSaga(action: any): any {
  let payload = action.payload;
       const isMobileSagaItemLevel = window.innerWidth <= 768;

  try {
    const response: AxiosResponse = yield call(validateCoupon, payload);
   
    
    // const decryptedData = decryptJson(response.data.data);

 
    if (response.status === 200 && response?.data?.status === 200) {
      console.log("ghgh");
      
      // Apply the FULL matched offer from the customer offers list — it carries
      // the complete bogo/freeList/category structure the validate response's
      // offerDetails lacks. Match by the promo code the user entered.
      const offersList: any[] = yield select((s: any) => s?.cart?.customerOffers || []);
      const matchedOfferId =
        response?.data?.offerDetails?.id ?? response?.data?.couponDetails?.offerId;

        console.log("ghgh",{matchedOfferId});
      const matched = (Array.isArray(offersList) ? offersList : []).find(
        (o: any) =>
          o?.offerCode === payload.couponCode ||
          (matchedOfferId && (o?.id === matchedOfferId || o?.id === matchedOfferId))
      );
        const menuDetails: any[] = yield select((s: any) => s?.restaurant?.restaurantMenuDetails || []);
       const menuItems = (Array.isArray(menuDetails) ? menuDetails : []).filter(
          (m: any) => m?.offerId === matchedOfferId && isMenuItemOrderable(m)
        );
        console.log({menuItems,matched});

      // ── Item-level offer via promo code ──
      // These offers are embedded on menu items (menuItem.offerId) and are NOT
      // in customerOffers. When the validate API confirms one (isItemLevel=1),
      // find the menu item that carries the offer and add it to the cart if
      // absent. The cart-watcher will stamp the offerId and apply the discount
      // automatically on the next tick.
      const offerDetailsFromApi = response?.data?.offerDetails;

      if (Number(offerDetailsFromApi?.isItemLevel) === 1 && matchedOfferId) {
      
        const cartItems: any[] = yield select((s: any) => s?.cart?.cart?.items || []);
        const appliedCouponsForItemLevel: any[] = yield select((s: any) => s?.restaurant?.appliedCoupons || []);
   

        // Guard: an exclusive coupon already applied blocks all new offers.
        const existingExclusiveForItemLevel = appliedCouponsForItemLevel.find(
          (c: any) => c?.combineOffer === true || c?.combine_offer === true
        );
       
        if (existingExclusiveForItemLevel) {
          const msg = 'This offer cannot be combined with the current offer.';
          isMobileSagaItemLevel ? showErrorToast(msg) : showErrorToastDesktop(msg);
          yield put(validateCouponFailureMessage({ httpStatus: 400, message: msg }));
          yield put(validateCouponFailure({ status: 400 }));
          return;
        }

        // Guard: incoming item-level offer is exclusive + another offer is already applied.
        const incomingItemLevelIsExclusive = Number(offerDetailsFromApi?.isExclusive) === 1;
        if (incomingItemLevelIsExclusive && appliedCouponsForItemLevel.length > 0) {
          const msg = "This offer cannot be combined with the current offer.11";
          isMobileSagaItemLevel ? showErrorToast(msg) : showErrorToastDesktop(msg);
          yield put(validateCouponFailureMessage({ httpStatus: 400, message: msg }));
          yield put(validateCouponFailure({ status: 400 }));
          return;
        }

       
        
      

        // Guard: a different item-level offer is already active on a cart item.
        // Block the incoming promo code so two conflicting item offers can't coexist.
        const hasConflictingItemOffer = (Array.isArray(cartItems) ? cartItems : []).some(
          (c: any) =>
            c?.offerId != null &&
            String(c.offerId) !== String(matchedOfferId) &&
            Number(c?.quantity || 0) > 0
        );
        if (hasConflictingItemOffer) {
          const msg = 'This item already has an offer applied. Remove it to apply this promo code.';
          isMobileSagaItemLevel ? showErrorToast(msg) : showErrorToastDesktop(msg);
          yield put(validateCouponFailureMessage({ httpStatus: 400, message: msg }));
          yield put(validateCouponFailure({ status: 400 }));
          return;
        }

        // All guards passed — remember the code the user typed against this
        // offerId. Item-level offers live on cart entries (stamped by the
        // cart-watcher) and are never added to `appliedCoupons`, so this map is
        // the only place the code survives to reach the totals/create-order
        // payload via buildOfferCaptureRequests. Stamp it before the
        // already-applied early return so re-entering the code still records it.
        const itemLevelEnteredCode: string =
          payload.couponCode || offerDetailsFromApi?.promoCode || '';
        yield put(setItemLevelPromoCode({
          offerId: String(matchedOfferId),
          promoCode: itemLevelEnteredCode,
        }));

        // If every menu item with this offer already has it applied in the cart,
        // the offer is already active — show a toast and stop.
        const allAlreadyApplied = menuItems.every((m: any) =>
          (Array.isArray(cartItems) ? cartItems : []).some(
            (c: any) => c?.itemId === m?.itemId && c?.offerId != null &&
              String(c.offerId) === String(matchedOfferId)
          )
        );
        if (allAlreadyApplied) {
          const msg = 'Offer already applied';
          isMobileSagaItemLevel ? showErrorToast(msg) : showErrorToastDesktop(msg);
          yield put(validateCouponSuccess(response?.data));
          return;
        }

        for (const menuItem of menuItems) {
          const alreadyInCart = (Array.isArray(cartItems) ? cartItems : []).some(
            (c: any) => c?.itemId === menuItem.itemId && Number(c?.quantity || 0) > 0
          );
          if (!alreadyInCart) {
            const basePrice = Number(menuItem?.price) || 0;
            const { options: defaultOptions, modifierPrice, modifierIds } =
              buildDefaultRequiredOptions(menuItem?.customization || []);
            const unitPrice = String(basePrice);
            const subTotal = String(
              Math.round((basePrice + modifierPrice) * 100) / 100
            );
            yield put(addCartItem({
              itemId: menuItem.itemId,
              itemName: menuItem.itemName || '',
              itemAltName: menuItem.itemAltName || '',
              quantity: '1',
              price: unitPrice,
              originalPrice: unitPrice,
              subTotal,
              comment: '',
              options: defaultOptions,
              tax: menuItem.tax || [],
              is_discount_applied: false,
              offer_data: null,
              offer_amount: 0,
              availability: menuItem.availability || null,
              isCustomizable: menuItem.isCustomizable || false,
              stockQuantity: menuItem.stockQuantity ?? null,
              alertQuantity: menuItem.alertQuantity ?? null,
              modifierIds,
            }));
          }

          // Queue celebration popup for each item added/upgraded.
          // Skip if the cart item already carries this offer (re-applying the same
          // promo code after the first cart visit cleared the queue — don't re-fire).
          try {
            const existingRaw = sessionStorage.getItem('pendingItemOfferUpgrades');
            const existing = existingRaw ? JSON.parse(existingRaw) : [];
            const alreadyQueued = Array.isArray(existing) &&
              existing.some((e: any) => e?.itemId === menuItem.itemId);
            const alreadyHasOffer = (Array.isArray(cartItems) ? cartItems : []).some(
              (c: any) => c?.itemId === menuItem.itemId && c?.offerId != null &&
                String(c.offerId) === String(matchedOfferId)
            );
            if (!alreadyQueued && !alreadyHasOffer) {
              const merged = Array.isArray(existing)
                ? [...existing, { itemId: menuItem.itemId, itemName: menuItem.itemName || '' }]
                : [{ itemId: menuItem.itemId, itemName: menuItem.itemName || '' }];
              sessionStorage.setItem('pendingItemOfferUpgrades', JSON.stringify(merged));
            }
          } catch { /* sessionStorage unavailable */ }
        }

        clearAllAutoApplySuppression();
        yield put(validateCouponSuccess({ httpStatus: 200, ...(response?.data || {}) }));
        return;
      }
      console.log({matched});
      

      if (matched) {
        // ── Server said 200 — re-run client-side guards ──
        // The validate API enforces neither combine/exclusivity rules nor
        // min_subtotal / BOGO-item / FREE_ITEM constraints. Mirror the UI
        // checks here so the offer is never blindly applied even from
        // programmatic paths.
        const cartItems: any[] = yield select((s: any) => s?.cart?.cart?.items || []);
        const appliedCoupons: any[] = yield select((s: any) => s?.restaurant?.appliedCoupons || []);
        const totals: any[] = yield select((s: any) => s?.cart?.totalDetails?.orderTotals || []);
        const cartSubtotal = Number(
          (totals.find((t: any) => t.code === '1') || {}).value ?? 0
        );
        const restaurantDetail: any = yield select((s: any) => s?.restaurant?.currentRestaurantDetail || {});
        const currencySymbol = restaurantDetail?.country === 'IN' ? '₹' : '$';
        // Detect mobile once; reused by every error branch below.
        const isMobileSaga = window.innerWidth <= 768;

        // Helper: fire toast + inline error + failure action, then bail out.
        const failWith = (message: string) => {
          isMobileSaga ? showErrorToast(message) : showErrorToastDesktop(message);
        };

        // ── Combine / exclusivity checks ──

        // 0. Same offer already applied — show a friendly message instead of
        //    the generic exclusivity error the checks below would otherwise hit.
        if (appliedCoupons.some((c: any) => c?.id === matched?.id)) {
          const msg = 'Offer already applied';
          failWith(msg);
          yield put(validateCouponFailureMessage({ httpStatus: 400, message: msg }));
          yield put(validateCouponFailure({ status: 400 }));
          return;
        }

        // A1. The subtotal this offer still has room to discount (cart items
        //     without an item-level offer or FREE_ITEM line) falls short of
        //     its min_subtotal → block incoming ORDER/FREE_DELIVERY offers.
        const incomingCatForLock = getOfferCategory(matched);
        if (
          (incomingCatForLock === 'ORDER' || incomingCatForLock === 'FREE_DELIVERY') &&
          isOrderLevelOfferLocked(cartItems, matched?.min_subtotal)
        ) {
          const msg = 'This offer cannot be applied to your cart';
          failWith(msg);
          yield put(validateCouponFailureMessage({ httpStatus: 400, message: msg }));
          yield put(validateCouponFailure({ status: 400 }));
          return;
        }

        // B. Incoming exclusive ORDER-level + another ORDER-level offer already applied.
        //    Item-level offers in cart do NOT count as a conflict — ORDER-level and
        //    item-level offers are always allowed to coexist.
        const incomingIsExclusive =
          matched?.combineOffer === true || matched?.combine_offer === true;
        const anyOfferAlreadyApplied = appliedCoupons.length > 0;
        if (incomingIsExclusive && anyOfferAlreadyApplied) {
          const msg = "This offer cannot be combined with the current offer.";
          failWith(msg);
          yield put(validateCouponFailureMessage({ httpStatus: 400, message: msg }));
          yield put(validateCouponFailure({ status: 400 }));
          return;
        }

        // C. An exclusive coupon already applied → blocks all new incoming.
        const existingExclusive = appliedCoupons.find(
          (c: any) =>
            (c?.combineOffer === true || c?.combine_offer === true) &&
            c?.id !== matched?.id
        );
        if (existingExclusive) {
          const msg = 'This offer cannot be combined with the current offer.';
          failWith(msg);
          yield put(validateCouponFailureMessage({ httpStatus: 400, message: msg }));
          yield put(validateCouponFailure({ status: 400 }));
          return;
        }

        // D. Same-category conflict (non-BOGO): only block when the existing
        //    same-category coupon is exclusive (combine_offer=true). Two
        //    non-exclusive coupons in the same category are allowed to stack.
        const incomingCatSaga = getOfferCategory(matched);
        if (incomingCatSaga !== 'BOGO') {
          const sameCatConflict = appliedCoupons.find(
            (c: any) =>
              getOfferCategory(c) === incomingCatSaga &&
              c?.id !== matched?.id &&
              isExclusiveCoupon(c)
          );
          if (sameCatConflict) {
            const catLabelMap: Record<string, string> = {
              ORDER: 'order level',
              FREE_ITEM: 'free item',
              FREE_DELIVERY: 'free delivery',
            };
            const catLabel = catLabelMap[incomingCatSaga] || incomingCatSaga.toLowerCase();
            const msg = `A ${catLabel} offer is already applied. Remove it first to apply this one.`;
            failWith(msg);
            yield put(validateCouponFailureMessage({ httpStatus: 400, message: msg }));
            yield put(validateCouponFailure({ status: 400 }));
            return;
          }
        }

        // E. Order-level offers are not applicable for event orders.
        if (incomingCatSaga === 'ORDER') {
          const eventSlugForOrder: string | null = yield select(getEventSlug);
          const eventDateForOrder: boolean = yield select(getEventDate);
          if (Boolean(eventDateForOrder) || Boolean(eventSlugForOrder)) {
            const msg = 'This offer is not applicable for event orders';
            failWith(msg);
            yield put(validateCouponFailureMessage({ httpStatus: 400, message: msg }));
            yield put(validateCouponFailure({ status: 400 }));
            return;
          }
        }

        // ── Eligibility checks ──

        // 1. Minimum subtotal
        const minSubtotal = Number(matched?.min_subtotal ?? 0);
        if (minSubtotal > 0 && cartSubtotal < minSubtotal) {
          const remaining = (minSubtotal - cartSubtotal).toFixed(2);
          const msg = `Add items worth ${currencySymbol}${remaining} more to apply this offer.`;
          failWith(msg);
          yield put(validateCouponFailureMessage({ httpStatus: 400, message: msg }));
          yield put(validateCouponFailure({ status: 400 }));
          return;
        }

        // 2. BOGO: buy items + at least one get item must be in cart
        const isBogoSaga =
          String(matched?.offer_type ?? matched?.offerType ?? '').toUpperCase() === 'BOGO';
        if (isBogoSaga) {
          const bogo = matched?.bogo;
          const buyItemIds: string[] = (Array.isArray(bogo?.buyItems) ? bogo.buyItems : [])
            .map((b: any) => b?.itemId)
            .filter(Boolean);
          const getItemIds: string[] = (Array.isArray(bogo?.getItems) ? bogo.getItems : [])
            .map((g: any) => g?.itemId)
            .filter(Boolean);
          const buyQty = Number(bogo?.buyQty || 1);
          const isSameItem = buyItemIds.some((id: string) => getItemIds.includes(id));
          let bogoIneligible = false;
          if (!bogo || buyItemIds.length === 0 || getItemIds.length === 0) {
            bogoIneligible = true;
          } else if (!bogoEqualOrLesserSatisfied(bogo, cartItems, buyItemIds, getItemIds)) {
            bogoIneligible = true;
          } else if (isSameItem) {
            const totalSame = cartItems.reduce(
              (sum: number, item: any) =>
                buyItemIds.includes(item?.itemId) ? sum + Number(item?.quantity || 0) : sum,
              0
            );
            bogoIneligible = totalSame < buyQty + 1;
          } else {
            let buyInCart = 0;
            let getInCart = 0;
            cartItems.forEach((item: any) => {
              const qty = Number(item?.quantity || 0);
              if (qty <= 0) return;
              if (buyItemIds.includes(item?.itemId)) {
                const isThisOffersGet =
                  item?.offer_data?.offerId === matched?.id &&
                  item?.is_discount_applied === true;
                buyInCart += isThisOffersGet ? 0 : qty;
              }
              if (getItemIds.includes(item?.itemId)) getInCart += qty;
            });
            bogoIneligible = !(buyInCart >= buyQty && getInCart >= 1);
          }
          if (bogoIneligible) {
            const msg = 'Add the required buy and get items to your cart to apply this BOGO offer.';
            failWith(msg);
            yield put(validateCouponFailureMessage({ httpStatus: 400, message: msg }));
            yield put(validateCouponFailure({ status: 400 }));
            return;
          }
        }

        // 3. FREE_ITEM: freeList must not be empty
        if (
          getOfferCategory(matched) === 'FREE_ITEM' &&
          !(Array.isArray(matched?.freeList) && matched.freeList.length > 0)
        ) {
          const msg = 'This free item offer is not available right now.';
          failWith(msg);
          yield put(validateCouponFailureMessage({ httpStatus: 400, message: msg }));
          yield put(validateCouponFailure({ status: 400 }));
          return;
        }
        // ── End guards ──

        yield put(validateCouponSuccess({ httpStatus: 200, ...(response?.data || {}) }));
        // A successful manual coupon apply lifts the global auto-apply
        // suppression set when the user removed an auto-applied offer.
        clearAllAutoApplySuppression();
        // FREE_ITEM offers need a chosen free item id (first in the list),
        // mirroring the CouponCard apply path.
        // Always stamp the entered promo code onto the applied coupon so
        // buildOfferCaptureRequests can include it in the totals API payload.
        const enteredPromoCode: string = payload.couponCode || matched?.promoCode || matched?.offerCode || (Array.isArray(matched?.promoCodes) ? matched?.promoCodes[0] : matched?.promoCodes) || '';
        console.log({enteredPromoCode});
        
        const applyPayload =
          getOfferCategory(matched) === 'FREE_ITEM' &&
          Array.isArray(matched?.freeList) &&
          matched.freeList.length > 0
            ? { ...matched, promoCode: enteredPromoCode, _chosenFreeItemId: matched.freeList[0] }
            : { ...matched, promoCode: enteredPromoCode };
        yield put(appliedCoupon(applyPayload));
      } else if (offerDetailsFromApi?.id) {

        // Valid per the API but not present in the local customerOffers list.
        // Apply directly from the API response so promo-only offers still work.
        const promoFromInput: string = payload.couponCode || offerDetailsFromApi?.promoCode || '';

        // Check if the offer matches menu items (item-level offer applied via promo code).
        const menuDetailsForPromo: any[] = yield select((s: any) => s?.restaurant?.restaurantMenuDetails || []);
        const cartItemsForPromo: any[] = yield select((s: any) => s?.cart?.cart?.items || []);
        const menuItemsForOffer = (Array.isArray(menuDetailsForPromo) ? menuDetailsForPromo : []).filter(
          (m: any) => m?.offerId === matchedOfferId && isMenuItemOrderable(m)
        );
           if (menuItems.length === 0  ) {
          const msg = 'Offer item is not available in this menu';
         const erorMsg= {
    "httpStatus": 400,
    "reasonCode": "OFFER_NOT_FOUND",
    "message": "This offer is not available at the moment."
}
          // isMobileSagaItemLevel ? showErrorToast(msg) : showErrorToastDesktop(msg);
        yield put(validateCouponFailure(erorMsg));
      yield put(validateCouponFailureMessage(erorMsg));
          return;
        }


        if (menuItemsForOffer.length > 0) {
          for (const menuItem of menuItemsForOffer) {
            const alreadyInCart = (Array.isArray(cartItemsForPromo) ? cartItemsForPromo : []).some(
              (c: any) => c?.itemId === menuItem.itemId && Number(c?.quantity || 0) > 0
            );
            if (!alreadyInCart) {
              const basePrice = Number(menuItem?.price) || 0;
              const { options: defaultOptions, modifierPrice, modifierIds } =
                buildDefaultRequiredOptions(menuItem?.customization || []);
              const unitPrice = String(basePrice);
              const subTotal = String(
                Math.round((basePrice + modifierPrice) * 100) / 100
              );
              yield put(addCartItem({
                itemId: menuItem.itemId,
                itemName: menuItem.itemName || '',
                itemAltName: menuItem.itemAltName || '',
                quantity: '1',
                price: unitPrice,
                originalPrice: unitPrice,
                subTotal,
                comment: '',
                options: defaultOptions,
                tax: menuItem.tax || [],
                is_discount_applied: false,
                offer_data: null,
                offer_amount: 0,
                availability: menuItem.availability || null,
                isCustomizable: menuItem.isCustomizable || false,
                stockQuantity: menuItem.stockQuantity ?? null,
                alertQuantity: menuItem.alertQuantity ?? null,
                modifierIds,
              }));
            }
          }
          yield put(setItemLevelPromoCode({ offerId: String(matchedOfferId), promoCode: promoFromInput }));
        }

        clearAllAutoApplySuppression();
        const offerFromApi = {
          ...offerDetailsFromApi,
          offerCode: offerDetailsFromApi?.promoCode || promoFromInput,
          promoCode: promoFromInput,
          offer_type: offerDetailsFromApi?.offerType,
        };
        yield put(validateCouponSuccess({ httpStatus: 200, ...(response?.data || {}) }));
        yield put(appliedCoupon(offerFromApi));
      } else {
        yield put(validateCouponFailure({ httpStatus: 400 }));
        console.log("Validate succeeded but offer not found in list", response.data);
        yield put(
          validateCouponFailureMessage({
            httpStatus: 400,
            message: 'Invalid promo code',
          })
        );
      }
    } else {
      // API error body is at response.data (e.g. { httpStatus: 400, reasonCode, message })
      const errBody = response?.data?.httpStatus ? response.data : (response?.data?.data ?? response?.data);
      // FIRST_TIME_ONLY: the offer requires a verified customer profile.
      // • Logged out → open login popup (on checkout: highlights Step 1).
      // • Logged in  → show a toast; they are ineligible for this first-time offer.
      if (errBody?.reasonCode === 'FIRST_TIME_ONLY') {
        const userId: string = yield select((s: any) => s?.auth?.user?.id ?? '');
        const isLoggedIn = !!userId;
        const isMobileSaga = window.innerWidth <= 768;
        if (isLoggedIn) {
          // const msg = errBody?.message || 'This offer is only valid for first-time orders.';
           const msg = 'Some offers are no longer available. Your order has been updated.';
          isMobileSaga ? showErrorToast(msg) : showErrorToastDesktop(msg);
        } else {
          yield put(setSignupPopupAction(true));
        }
        return;
      }
      console.log({errBody});
      
      yield put(validateCouponFailure(errBody));
      yield put(validateCouponFailureMessage(errBody));
    }
  } catch (err: any) {
    yield put(validateCouponFailure(err));
  }
}

function* redeemCouponSaga(action: any) {
  let payload = action.payload

  try{
    const response: AxiosResponse = yield call(redeemCoupon, payload)
    if(response.status === 200){
      yield put(redeemCouponSuccess(response.data))
    }else{
      yield put(redeemCouponFailure(response.data))
    }
  }catch(err: any){
    yield put(redeemCouponFailure(err))
  }
}


export default function* restaurantSaga() {
  yield takeLatest(RESTAURANT_DETAIL_REQUEST, getRestaurantDetailsSaga);
  yield takeLatest(
    RESTAURANT_DETAIL_LOCATION_ID_REQUEST,
    getRestaurantDetailsByLocationIdSaga
  );
  yield takeLatest(RESTAURANT_MENU_DETAIL_REQUEST_BY_DATE,getRestaurantMenuDetailsByDateSaga);
  yield takeLatest(
    RESTAURANT_MENU_DETAIL_REQUEST,
    getRestaurantMenuDetailsSaga
  );
  yield takeLatest(FEEDBACK_DETAIL_REQUEST, getFeedbackDetailsSaga);
  yield takeLatest(SUBMIT_FEEDBACK_DETAIL_REQUEST, SubmitFeedbackDetailsSaga);
  yield takeLatest(RESTAURANTS_REQUEST, getLocationRestaurantsSaga);
  yield takeLatest(SERVING_RESTAURANTS_REQUEST, getServingRestaurantsSaga);
  yield takeLatest(
    ACTIVE_ORDER_RESTAURANT_REQUEST,
    getActiveOrderRestaurantSaga
  );
  yield takeLatest(GET_MASTER_HOME_PAGE_DETAILS, getMasterHomePageDetailsSaga);
  yield takeLatest(GET_RESTAURANT_TABLE_DETAILS, getRestaurantTableDetailsSaga);
  yield takeLatest(ADD_DELIVERY_ADDRESS_REQUEST, addDeliveryAddressSaga);
  yield takeLatest(VIEW_DELIVERY_ADDRESS_REQUEST, viewDeliveryAddressSaga);
  yield takeLatest(EDIT_DELIVERY_ADDRESS_REQUEST, editDeliveryAddressSaga);
  // yield takeLatest(VIEW_DELIVERY_ADDRESS_REQUEST, viewDeliveryAddressSaga);
  yield takeLatest(DELETE_DELIVERY_ADDRESS_REQUEST, deleteDeliveryAddressSaga);
  yield takeLatest(ADD_FAV_REQUEST, addFavSaga);
  yield takeLatest(REMOVE_FAV_REQUEST, removeFavSaga);
  yield takeLatest(GET_FAV_REQUEST, getFavSaga);
  yield takeLatest(GET_EXPLORE_MENU_REQUEST, getExploreMenuSaga)
    yield takeLatest(GET_COUPONS_REQUEST, getCouponSaga);
  yield takeLatest(VALIDATE_COUPONS_REQUEST, validateCouponSaga);
  yield takeLatest(REDEEM_COUPONS_REQUEST, redeemCouponSaga)
}
